module.exports = __webpack_public_path__ + "img/earth.9f55a6dc.png";